import React from 'react';
import PropTypes from 'prop-types';
import dumbBem from 'dumb-bem';
import tx from 'transform-props-with';
import Appear from 'components/common/reactAppear';

import {
  ContentBullet,
  Content,
  Block,
} from 'components/landing/components';

import { Offer } from './Offer';
import './Careers.css';

const dumbCareers = dumbBem('l-careers');
const Offers = tx([{ element: 'offers' }, dumbCareers])('div');

const PositionList = ({
  offersRef,
  title,
  positions,
  onNavigate,
}) => {
  return (
    <Block modifier="content" __ref={offersRef}>
      <ContentBullet title={title} />

      <Content modifier="content">
        <Offers>
          {
            positions.map((position, id) => (
              <Appear className="l-careers appear-animation" key={id}>
                <Offer onNavigate={() => onNavigate(position.url)} {...position} />
              </Appear>
            ))
          }
        </Offers>
      </Content>
    </Block>
  );
};

PositionList.propTypes = {
  offersRef: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  positions: PropTypes.array.isRequired,
  onNavigate: PropTypes.func.isRequired,
};

export default PositionList;



// WEBPACK FOOTER //
// ./src/components/landing/pages/careers/PositionList.jsx